module.exports = "<template #container></template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dynamic-component/dynamic-component.component.html
// module id = 1935
// module chunks = 0